<template>
  <section class="brandStory_main">
    <div class="container in_wrap">
      <div>
        <p>
          <span>세상에서 가장</span>
          아름다운 피부 본연의
        </p>
        <p class="msg">
          빛을 위한 노력
        </p>
        <a href="" class="go" @click.prevent="$router.push('/brandstory')">자세히보기</a>
      </div>
      <div class="different">
        <div class="logo_wrap">
          <img
            src="@/assets/images/common/logo_incellderm_typo.svg"
            class="logo"
            alt="incellderm"
          />
        </div>
        <p class="txt">
          인셀덤은 자연 유래 성분과 11개 특허 성분을 함유하고 있으며<span class="brs"></span>
          인셀덤의 모든 제품과 원료는 국내 및 글로벌 기준 적합 여부 및 안전성을 확인한 후 사용하고 있습니다.<br />
          수많은 연구와 노력의 결실로 어리고 건강한 세포 본연의<span class="brs"></span>
          빛을 살려내기 위한 비밀 찾기에 이르렀고, 이 기술을 바탕으로 독보적인
          스킨케어 솔루션을 재창조하였습니다.
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'BrandStory',
};
</script>

<style></style>
